export const INVITATION_API = '/api/invitations';

export const DEFAULT_PAGE_SIZE = 25;
